import React from "react";
import "../../styles/Menu.scss";
import { useNavigate } from "react-router-dom";

const Menu: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = (item: string) => {
    if (item === "Marketplace") {
      window.open("https://gottit.io/", "_blank");
    } else if (item === "Gottix") {
      navigate("/");
    }
  };

  return (
    <div className="menu-wrapper">
      <div className="menu-container">
        {["Marketplace", "Gottix"].map((item, index) => (
          <React.Fragment key={item}>
            <div
              className={`menu-item ${item === "Gottix" ? "active" : ""}`}
              onClick={() => handleClick(item)}
            >
              {item}
            </div>
            {index === 0 && <div className="menu-divider" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Menu;





// import React from "react";
// import "../../styles/Menu.scss";
// import { useNavigate } from "react-router-dom";

// const Menu: React.FC = () => {
//   const navigate = useNavigate();

//   const handleClick = (item: string) => {
//     if (item === "Gottravel" || item === "Gottit Pro") return;

//     if (item === "Marketplace") {
//       window.open("https://gottit.io/", "_blank");
//     } else if (item === "Gottix") {
//       navigate("/");
//     }
//   };

//   return (
//     <div className="menu-wrapper">
//       <div className="menu-container">
//         {["Marketplace", "Gottix",].map((item) => (
//           <div
//             key={item}
//             className={`menu-item 
//               ${item === "Gottix" ? "active" : ""} 
//               ${item === "Gottravel" || item === "Gottit Pro" ? "disabled" : ""}
//             `}
//             onClick={() => handleClick(item)}
//           >
//             {item}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Menu;
